module.exports = {
      id: "car-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#car-icon",
      toString: function () {
        return this.url;
      }
    }